export default function React_Home() {
  return (
    <div>
      <h1>React_Home Component</h1>
      <p>This is the React_Home tutorial page.</p>
    </div>
  );
}
